import { render, staticRenderFns } from "./NbAdd.vue?vue&type=template&id=31c7cf4e"
import script from "./NbAdd.vue?vue&type=script&lang=js"
export * from "./NbAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports